import type {FC} from 'react';
import moment from 'moment';
import {Link} from 'components/Link';
import {adminRoles} from 'utils/Forms';
import {Box, Stack, Typography} from '@wellstone-solutions/web';
import type {Member} from 'api/v2';

interface StaffProfileCellProps {
  staff: Member;
}

export const StaffProfileCell: FC<StaffProfileCellProps> = ({staff}) => {
  const role = adminRoles.find((role) => role.value === staff.role);
  const lastLogin = staff.user.lastLogin
    ? moment(staff.user.lastLogin).format('MMM D, YYYY')
    : 'Never logged in';

  return (
    <Link to={`/staff/${staff.id}`} sx={styles.wrapper}>
      <Stack justifyContent="center" sx={{height: '100%'}}>
        <Typography noWrap className="link" sx={styles.name}>
          {staff.name}
        </Typography>
        <Typography noWrap sx={styles.subText}>
          {role?.name || '-'}
        </Typography>
        <Typography sx={styles.subText}>
          <Box sx={{fontWeight: 700}} component="span">
            Last Login:{' '}
          </Box>
          {lastLogin}
        </Typography>
      </Stack>
    </Link>
  );
};

const styles = {
  wrapper: {
    flex: 1,
    width: '100%',
    height: '100%',
    py: 2,
    '&:hover .link': {
      textDecoration: 'underline',
    },
  },
  name: {
    fontWeight: 700,
    fontSize: 14,
    color: 'link.main',
  },
  subText: {
    fontSize: 14,
    color: 'onSurface.main',
  },
};
